var PRODUCT_DISPLAY_ROW_MOBILE = 2;

(function(){
  /* filter listを開いた状態にする */
  const filterForm = document.getElementById('FiltersForm');
  if(filterForm){
    const filterFormListItems = filterForm.querySelectorAll('.filterby__list-item');
    filterFormListItems.forEach((formListItem) => {
      formListItem.setAttribute('open', '');
    });
  }

  /* mobile 表示列数変更 */
  const displayRowArea = document.querySelector('.select-display-row');
  if(displayRowArea){
    const rowButtons = displayRowArea.querySelectorAll('button');
    rowButtons.forEach((rowButton) => {
      rowButton.addEventListener('click', function() {
        PRODUCT_DISPLAY_ROW_MOBILE = this.dataset.row;
        rowButtons.forEach((rowButton) => {
          rowButton.classList.remove('active');
        });
        this.classList.add('active');
        setProductDisplayRow();
        if(animationStatus){
          if (AOS) { 
              AOS.refreshHard() 
          }
        }
      });
    });
  }
})();
  
function setProductDisplayRow(){
  let productList = document.querySelectorAll('.product-box');
  productList.forEach((productRow) => {
    let classNameList = 'col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 product-box';
    if(PRODUCT_DISPLAY_ROW_MOBILE == 1){
      classNameList = 'col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 product-box';
    }else if(PRODUCT_DISPLAY_ROW_MOBILE == 3){
      classNameList = 'col-4 col-sm-4 col-md-4 col-lg-3 col-xl-3 product-box';
    }
    productRow.className = classNameList;
  });
}